/**
 * @generated SignedSource<<3e2462bddc40da34031d84b847f35420>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PermissionType = "ADMIN" | "NONE" | "READ" | "WRITE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OwnerSettings_info$data = {
  readonly description: {
    readonly actions: ReadonlyArray<{
      readonly link: string;
      readonly title: string;
    }>;
    readonly message: string;
  };
  readonly name: string;
  readonly platform: string;
  readonly uid: string;
  readonly viewerPermission: PermissionType;
  readonly " $fragmentSpreads": FragmentRefs<"MonthlyUsageChart_info" | "OwnerApiSettings_info" | "OwnerComputeCredits_info" | "OwnerPersistentWorkerPools_info" | "OwnerSecuredVariables_info" | "WebHookSettings_info">;
  readonly " $fragmentType": "OwnerSettings_info";
};
export type OwnerSettings_info$key = {
  readonly " $data"?: OwnerSettings_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"OwnerSettings_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnerSettings_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerPermission",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OwnerInfoDescription",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OwnerInfoDescriptionAction",
          "kind": "LinkedField",
          "name": "actions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OwnerComputeCredits_info"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MonthlyUsageChart_info"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OwnerApiSettings_info"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OwnerSecuredVariables_info"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OwnerPersistentWorkerPools_info"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WebHookSettings_info"
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "00f56ef4123b4921848d63680d675f7b";

export default node;
